import React from 'react';
import { MdArrowForward } from 'react-icons/md';
import { Link } from 'react-router-dom';
import ContainedButton from 'components/layout/form/containedButton';
import AlertInline from 'components/layout/AlertInline'
import { HeaderContainer } from "../styles";
import { ButtonContainer, Section } from './styles';

const SuccessRegister = () => {
  return (
    <Section>
      <HeaderContainer>
          <h1>Tudo certo!!</h1>
          <h2>Agora você pode acessar seu portal e visualizar todas suas unidades em um único login.</h2>
      </HeaderContainer>

      <ButtonContainer>
        <Link to="/">
          <ContainedButton
            color="#4EC937"
            TrailingIcon={() => <MdArrowForward size={20}/>}
          >
            Acesse o portal
          </ContainedButton>
        </Link>
      </ButtonContainer>

      <AlertInline text="Em até 60 dias você receberá seu primeiro boleto." textFontSize='0.8rem' />
    </Section>
  );
};

export default SuccessRegister;
